import { Injectable } from '@angular/core';
import { nanoid } from 'nanoid';

@Injectable({
  providedIn: 'root',
})
export class IdService {
  public generateRandomId(): string {
    return nanoid(10);
  }
}
